export function isItemVisible(
  item,
  { mainMenuPermissions = [], products, beegolAccess, customer, isMonitoring }
) {
  if (item.key && !mainMenuPermissions.includes(item.key)) {
    return false
  }

  const { visible, monitoring } = item
  const hasVisible = typeof visible !== "undefined"
  const hasMonitoring = typeof monitoring !== "undefined"

  if (!hasVisible && !hasMonitoring) {
    return true
  }

  if (hasVisible && !hasMonitoring) {
    return visible({ products, beegolAccess, customer })
  }

  if (hasMonitoring && !hasVisible) {
    return monitoring(isMonitoring)
  }

  return false
}



// WEBPACK FOOTER //
// ./src/components/ModernLayout/Menu/isItemVisible.js